import React from "react";

const Pagination = ({ totalPages, currentPage, onPageChange, totalCount }) => {
    const handlePageChange = (page) => {
        if (page >= 0 && page < totalPages) {
            onPageChange(page);
        }
    };

    const getPageNumbers = () => {
        const pages = [];

        if (totalPages <= 5) {
            for (let i = 0; i < totalPages; i++) {
                pages.push(i);
            }
        } else {
            pages.push(0);

            if (currentPage > 2) {
                pages.push("dots-before");
            }

            const start = Math.max(1, currentPage - 1);
            const end = Math.min(totalPages - 2, currentPage + 1);

            for (let i = start; i <= end; i++) {
                pages.push(i);
            }

            if (currentPage < totalPages - 3) {
                pages.push("dots-after");
            }

            pages.push(totalPages - 1);
        }

        return pages;
    };

    const pagesToDisplay = getPageNumbers();

    return (
        <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4 mt-4 w-full">
            {/* Total Count */}
            <div className="text-sm text-gray-600">
                Showing page <span className="font-medium">{currentPage + 1}</span> of{" "}
                <span className="font-medium">{totalPages}</span>
                {typeof totalCount !== "undefined" && (
                    <> – Total: <span className="font-semibold">{totalCount}</span> items</>
                )}
            </div>

            {/* Pagination Controls */}
            <nav className="flex items-center flex-wrap gap-1">
                <button
                    className="px-3 py-1 text-sm bg-gray-200 rounded hover:bg-gray-300 disabled:opacity-50"
                    onClick={() => handlePageChange(currentPage - 1)}
                    disabled={currentPage === 0}
                >
                    Prev
                </button>

                {pagesToDisplay.map((page, index) =>
                        page === "dots-before" || page === "dots-after" ? (
                            <span key={index} className="px-2 text-gray-400">
              ...
            </span>
                        ) : (
                            <button
                                key={page}
                                className={`px-3 py-1 text-sm rounded transition ${
                                    currentPage === page
                                        ? "bg-teal-500 text-white"
                                        : "bg-gray-200 hover:bg-gray-300"
                                }`}
                                onClick={() => handlePageChange(page)}
                            >
                                {page + 1}
                            </button>
                        )
                )}

                <button
                    className="px-3 py-1 text-sm bg-gray-200 rounded hover:bg-gray-300 disabled:opacity-50"
                    onClick={() => handlePageChange(currentPage + 1)}
                    disabled={currentPage === totalPages - 1}
                >
                    Next
                </button>
            </nav>
        </div>
    );
};

export default Pagination;
